import { render, staticRenderFns } from "./FreezingPointDepression.vue?vue&type=template&id=1f3bcda6&"
import script from "./FreezingPointDepression.vue?vue&type=script&lang=js&"
export * from "./FreezingPointDepression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports